var styles = {"option":"styles_option__DjBDd","icon":"styles_icon__qAaxw","label":"styles_label__rjg-5","text":"styles_text__dTZEb","ellipsis":"styles_ellipsis__v8BdP","active":"styles_active__-HhuV"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
